import { api } from 'services/api';

const notificationService = api.enhanceEndpoints({ addTagTypes: ['Notification'] }).injectEndpoints({
  endpoints: (builder) => ({
    notifications: builder.query<ResultModel<NotificationResp[]>, NotificationsRequest>({
      query: (body) => ({
        url: `/5A3D76B839D1770F9281663E/NotificationList`,
        method: 'POST',
        body,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ id }) => ({
                type: 'Notification' as const,
                id: id,
              })),
              { type: 'Notification', id: 'LIST' },
            ]
          : [{ type: 'Notification', id: 'LIST' }],
      extraOptions: { isProfile: true },
    }),
    // prettier-ignore
    deleteNotifications: builder.mutation<ResultModel<DeleteNotificationsResponse>, DeleteNotificationsRequest>({
      query: (body) => ({
        url: `/5A3D76B839D1770F9281663E/DeleteSelectedNotifications`,
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: 'Notification', id: 'LIST' }],
    }),
    // prettier-ignore
    readNotifications: builder.mutation<ResultModel<DeleteNotificationsResponse>, ReadNotificationsRequest>({
      query: (body) => ({
        url: `/5A3D76B839D1770F9281663E/MarkSelectedNotificationsAsRead`,
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: 'Notification', id: 'LIST' }],
    }),
  }),
});

export const { useNotificationsQuery, useDeleteNotificationsMutation, useReadNotificationsMutation } =
  notificationService;
